import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../../../services/user.service';
import { AdministrationService } from '../../../../services/administration.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';

@Component({
  selector: 'app-swk-government',
  templateUrl: './swk-government.component.html',
  styleUrls: ['./swk-government.component.css']
})
export class AccountOfficeSwkGovernmentComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  warrantAuthCode: string = 'SW';
  errorMessage: string = '';
  isSubmit: boolean = false;
  userName: string = '';
  screenCode: string = '';
  agentCodes = [];
  datasource = [];
  mailToList = [];
  mailCCList = [];
  mailBCCList = [];
  swkaccoffform: FormGroup;
  mailtoform: FormGroup;
  mailccform: FormGroup;
  mailbccform: FormGroup;

  constructor(private userService: UserService,
    private administrationService: AdministrationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.swkaccoffform = new FormGroup({
      selectedAgentCode: new FormControl({ value: '', disabled: false })
    });

    this.mailtoform = new FormGroup({
      mailTo: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
    });

    this.mailccform = new FormGroup({
      mailCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
    });

    this.mailbccform = new FormGroup({
      mailBCC: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
    });

    let getAccOff = {
      AccOffCode: '',
      AccOff: '',
      MailTo: '',
      MailCc: '',
      MailBcc: ''
    };

    let getagency_sub = this.administrationService.getSwkAccountOfficeList(getAccOff)
      .subscribe(
        (value) => {
          this.isSubmit = false;
          if (value.status === 204) {

          } else if (value.status === 200) {
            this.agentCodes = value.body['agentCodes'];
            this.datasource = value.body['accountOffices'];

            this.datasource.forEach((item, index) => {
              if (item.MailTo) {
                this.mailToList = item.MailTo.split(',');
              }
              if (item.MailCc) {
                this.mailCCList = item.MailCc.split(',');
              }
              if (item.MailBcc) {
                this.mailBCCList = item.MailBcc.split(',');
              }
            });

            this.swkaccoffform.setValue({
              selectedAgentCode: this.agentCodes[0].Airline_Agency_Code
            });
          } else {
            this.openSnackBar('Error retrieving account office list.', '');
          }
        },
        (error) => {
          this.isSubmit = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(getagency_sub);
  }

  saveAccOff(form: FormGroup) {
    if (this.mailToList.length === 0) {
      this.openSnackBar('Mail To cannot be empty.', '');
      return;
    }

    let cfm = confirm("Are you sure you want to save the change(s)?");

    if (cfm) {
      this.isSubmit = true;
      let accountOfficeDetail = {
        WarrantAuthCode: this.warrantAuthCode,
        AccOffCode: 0,
        AccOff: '',
        MailTo: this.mailToList,
        MailCc: this.mailCCList,
        MailBcc: this.mailBCCList
      }

      let save_sub = this.administrationService.swkUpdateAccOff(accountOfficeDetail)
        .subscribe(
          (value) => {
            if (value.status === 204) {

            } else if (value.status === 200) {
              this.isSubmit = false;
              this.openSnackBar('Change(s) Saved.', '');
            } else {

            }
          },
          (error) => {
            this.errorMessage = <any>error;
            this.openSnackBar(this.errorMessage, '');
          });

      //Adds into array for each subscribe
      this.allSub.push(save_sub);
    } else {
      this.isSubmit = false;
    }
  }

  addMailTo(form: FormGroup) {
    if (this.mailtoform.get('mailTo')!.value.length > 0) {
      this.mailToList.push(this.mailtoform.get('mailTo')!.value);

      this.mailtoform.setValue({
        mailTo: ''
      });
    } else {
      this.openSnackBar('Invalid Email.', '');
    }
  }

  addMailCC(form: FormGroup) {
    if (this.mailccform.get('mailCC')!.value.length > 0) {
      this.mailCCList.push(this.mailccform.get('mailCC')!.value);

      this.mailccform.setValue({
        mailCC: ''
      });
    } else {
      this.openSnackBar('Invalid Email.', '');
    }
  }

  addMailBCC(form: FormGroup) {
    if (this.mailbccform.get('mailBCC')!.value.length > 0) {
      this.mailBCCList.push(this.mailbccform.get('mailBCC')!.value);

      this.mailbccform.setValue({
        mailBCC: ''
      });
    } else {
      this.openSnackBar('Invalid Email.', '');
    }
  }

  deleteMailToList(mailTo: string) {
    var index = this.mailToList.indexOf(mailTo);
    if (index !== -1) this.mailToList.splice(index, 1);
  }

  deleteMailCcList(mailCc: string) {
    var index = this.mailCCList.indexOf(mailCc);
    if (index !== -1) this.mailCCList.splice(index, 1);
  }

  deleteMailBccList(mailBcc: string) {
    var index = this.mailBCCList.indexOf(mailBcc);
    if (index !== -1) this.mailBCCList.splice(index, 1);
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
